import { LocalStorage } from '@kulee/helper'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n.use(Backend).use(initReactI18next)

// 语言列表
const LANGUAGES = [
  { label: 'English', value: 'en' },
  { label: 'Türkçe', value: 'tr' },
  { label: '中文', value: 'zh' }
]
// 默认语言
const DEFAULT_LANG = LANGUAGES[0].value
// 本地存储key
const LANG_KEY = 'tga-lang'

/**
 * 获取本地语言
 * @returns 本地语言
 */
const getLocalLang = (): string => {
  // 从 localStorage 获取语言
  const localLang = LocalStorage.getItem<string>(LANG_KEY)
  if (localLang && LANGUAGES.some(item => item.value === localLang)) {
    return localLang
  }
  // 从浏览器语言中获取语言
  const browserLang = navigator.language.split('-')[0]
  if (LANGUAGES.some(item => item.value === browserLang)) {
    return browserLang
  }
  // 默认语言
  return DEFAULT_LANG
}

/**
 * 设置本地语言
 * @param lang 语言
 */
const setLocalLang = (lang: string) => {
  LocalStorage.setItem(LANG_KEY, lang)
}

const i18nInit = async () => {
  return i18n.init({
    debug: true,
    lng: getLocalLang(),
    fallbackLng: DEFAULT_LANG,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=5.1.6',
      addPath: '/locales/{{lng}}/{{ns}}.json?v=5.1.6'
    },
    load: 'languageOnly'
  })
}

export { i18nInit, getLocalLang, setLocalLang, LANGUAGES, DEFAULT_LANG }

export default i18n
